import { getPlatform } from '@/helpers/environmentHelper';
import axios from 'axios';

const debug = window.config.debug;

export async function logToServer(level: 'info' | 'error' | 'warn' = 'info', message: string) {
    const logLayout = getLayout();

    if (debug) {
        try {
            const expressUrl = window.config.integration.express.rest;
            return await axios.post(
                `${expressUrl}/logs`,
                { layout: logLayout, level, message },
                { headers: { Authorization: `Bearer ${process.env.REACT_APP_API_SECRET}` } }
            );
        } catch (error) {
            return await console.error(error);
        }
    }
}

export function getLayout() {
    const platform = getPlatform();
    if (platform.includes('wl')) {
        return 'wl-test';
    } else if (platform.includes('mh')) {
        return 'wl-mohicans';
    } else if (platform.includes('paytech')) {
        return 'wl-paytech';
    } else if (platform.includes('wolfbtc')) {
        return 'wl-wolfbtc';
    }
    return platform;
}
